export default "/images/almbrand.webp?e4c943f4506df3015e7366c2fd71d911";